/*　include
------------------------------------------------------- */

import "core-js/stable";
import "regenerator-runtime/runtime";
import './scss/style.scss';

/*
------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(function() {
    $("#logo").addClass("fadeIn");
    $("#btn01").addClass("fadeIn");
  }, 2750);
});

document.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(function() {
    $(".el_common_ttl").addClass("fadeInB");
  }, 2780);
});

document.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(function() {
    $(".el_common_ttl").addClass("fadeIn");
    $(".ly_main_ttl time").addClass("fadeIn");
    $(".ly_main_ttl h3").addClass("fadeIn");
    $(".ly_main_ttl p.tag").addClass("fadeIn");
  }, 1700);
});

$(window).on('scroll', function (){
  var elem = $('.ly_main_cradit, .ly_main_member, .ly_main_outline, .ly_main_profile, .ly_main_works-slider');
  var isAnimate = 'fadeInC';
  elem.each(function () {
    var elemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();
    if(scrollPos > elemOffset - wh + (wh / 7) ){
      $(this).addClass(isAnimate);
    }
  });
});

document.addEventListener('DOMContentLoaded', (event) => {
let splashWrapA = CSSRulePlugin.getRule(".el_splash");
let splashAfter = CSSRulePlugin.getRule(".el_splash:after");
let splashTlA = new TimelineMax({
  delay: 0,
})
.to(splashAfter,0.8,{ease:Power3.easeInOut,cssRule:{scaleX:0}}, 'gate')
.to(splashAfter,1,{cssRule:{display:"none"}}, 'gate');
});

document.addEventListener('DOMContentLoaded', (event) => {
let splashWrap = CSSRulePlugin.getRule(".el_splash");
let splashBefore = CSSRulePlugin.getRule(".el_splash:before");
let openingTtl = CSSRulePlugin.getRule(".el_splash_inner_logo_ttl");
let splashTl = new TimelineMax({
  delay: 1,
})
.to(splashBefore,1,{ease:Power3.easeInOut,cssRule:{scaleX:0}}, 'gate')
.to(splashWrap,1,{cssRule:{display:"none"}}, 'gate');
});

$(document).ready(function() {
    $(window).bind("load", function() {
    

    
    });  
});

$(function() {
$('.js_header_btn').hover(function() {
$(this).css('transform', 'scale(0.9)')
}, function() {
$(this).css('transform', 'scale(1.0)')
});
});

$(function() {
  $("#btn01,header.ly_header .ly_header_inner .un_closeArea").on("click", function() {
    $('.ly_header').toggleClass('active-sp')
  });
});

$(document).on('change', function (e) {
  var tA=e.target;
  if(tA.name=="type"){
    document.querySelector('[name="type-b"][value="'+tA.value+'"]').checked=true;
  };
});
$(document).on('change', function (e) {
    var tB=e.target;
    if(tB.name=="member"){
      document.querySelector('[name="member-b"][value="'+tB.value+'"]').checked=true;
    };
});
$(document).on('change', function (e) {
    var tC=e.target;
    if(tC.name=="type-b"){
      document.querySelector('[name="type"][value="'+tC.value+'"]').checked=true;
    };
});
$(document).on('change', function (e) {
    var tD=e.target;
    if(tD.name=="member-b"){
      document.querySelector('[name="member"][value="'+tD.value+'"]').checked=true;
    };
});

function tabResult1(){
  let str = "";
  const result = document.getElementsByName("type");
  for (let i = 0; i < result.length; i++){
    if(result[i].checked){
      str = result[i].value;
      break;
    }
  }
  document.getElementById("type-result").textContent = str;
  document.getElementById("type-result-b").textContent = str;
}

function tabResult2(){
  let str = "";
  const result = document.getElementsByName("member");
  for (let i = 0; i < result.length; i++){
    if(result[i].checked){
      str = result[i].value;
      break;
    }
  }
  document.getElementById("member-result").textContent = str;
  document.getElementById("member-result-b").textContent = str;
}

function tabResult3(){
  let str = "";
  const result = document.getElementsByName("type-b");
  for (let i = 0; i < result.length; i++){
    if(result[i].checked){
      str = result[i].value;
      break;
    }
  }
  document.getElementById("type-result").textContent = str;
  document.getElementById("type-result-b").textContent = str;
}

function tabResult4(){
  let str = "";
  const result = document.getElementsByName("member-b");
  for (let i = 0; i < result.length; i++){
    if(result[i].checked){
      str = result[i].value;
      break;
    }
  }
  document.getElementById("member-result").textContent = str;
  document.getElementById("member-result-b").textContent = str;
}

$(function () {
    $('input[name="type"],input[name="member"],input[name="type-b"],input[name="member-b"]').change(function () {
      $('ul.results').addClass('visible');
      tabResult1();
      tabResult2();
      $('.js_sort-hover').addClass('sort-on');
      $('.js_scroll-tab').addClass('result-on');
      $('.js_sort ul li:nth-child(1).clicked').removeClass('clicked');
    });
});

$(function () {
    $('input[name="type-b"],input[name="member-b"]').change(function () {
      tabResult3();
      tabResult4();
    });
});

$(function () {
    $('input[name="type"],input[name="type-b"]').change(function () {
      $('ul.results li.type-result').addClass('visible');
    });
});

$(function () {
    $('input[name="member"],input[name="member-b"]').change(function () {
      $('ul.results li.member-result').addClass('visible');
    });
});

$(document).ready(function() {
let toggleButton = document.querySelector('.js_header_btn');
toggleButton.addEventListener('click',function(){
    let target = this.nextElementSibling;
    const result = target.classList.contains('open');
    if (result) {
        target.classList.remove('open');
        gsap.to(target,{
            width: '0vw',
            duration:0.5,
            ease: "power2.inOut"
        });
    }else{
        target.classList.add('open');
        gsap.to(target,{
            width:'100vw',
            duration:0.5,
            ease: "power2.inOut"
        });
    }
})
});

$(document).ready(function() {
let closeArea = document.querySelector('.un_closeArea');
closeArea.addEventListener('click',function(){
    let target = document.querySelector('.ly_header_inner');
    const result = target.classList.contains('open');
    if (result) {
        target.classList.remove('open');
        gsap.to(target,{
            width: '0vw',
            duration:0.5,
            ease: "power2.inOut"
        });
    }else{
        target.classList.add('open');
        gsap.to(target,{
            width:'100vw',
            duration:0.5,
            ease: "power2.inOut"
        });
    }
})
});

$.fn.clickToggle = function (a, b) {
  return this.each(function () {
    var clicked = false;
    $(this).on('click', function () {
      clicked = !clicked;
      if (clicked) {
        return a.apply(this, arguments);
      }
      return b.apply(this, arguments);
    });
  });
};

const mediaQuery = window.matchMedia('(max-width: 768px)');
handle(mediaQuery);
mediaQuery.addListener(handle);
function handle(mm) {
  if (mm.matches) {
$(function(){
  $('.js_header_btn').on('click', function() {
    $(this).toggleClass('active');
    return false;
  });
  $(".un_closeArea").on("click", function() {
    $(".js_header_btn").removeClass("active");
  });
$("#btn01").on("click", function() {
  setTimeout(function() {
  $(".ly_header_inner_left").toggleClass("sp-open");
  $(".ly_header_inner_right").toggleClass("sp-open");
  $("#logo.sp").toggleClass("sp-open");
  $(".ly_header_inner_sns").addClass("sp-open");
  $(".ly_header_inner_sns").removeClass("sp-close");
  },550);
});
$("#btn01").on("click", function() {
  $(".ly_header_inner_sns").removeClass("sp-open");
  $(".ly_header_inner_sns").addClass("sp-close");
});
$(".un_closeArea").on("click", function() {
  $(".ly_header_inner_left").removeClass("sp-open");
  $(".ly_header_inner_right").removeClass("sp-open");
  $(".ly_header_inner_sns").removeClass("sp-open");
  $("#logo.sp").removeClass("sp-open");
});
});
  } else {
$(".js_header_btn").on("click", function() {
  setTimeout(function() {
    $(".ly_header_inner_left").removeClass("hidden");
    $(".ly_header_inner_sns").removeClass("hidden");
    $(".ly_header_inner_right").removeClass("hidden");
  },550);
  setTimeout(function() {
    $(".ly_header_inner_right").addClass("visible");
  },350);
  setTimeout(function() {
    $(".ly_header_inner_left").addClass("visible");
    $(".ly_header_inner_sns").addClass("visible");
  },900);
});
$(".un_closeArea").on("click", function() {
  $(".ly_header_inner_left").removeClass("visible");
  $(".ly_header_inner_right").removeClass("visible");
  $(".ly_header_inner_left").addClass("hidden");
  $(".ly_header_inner_sns").addClass("hidden");
  $(".ly_header_inner_sns").removeClass("visible");
});
  }
}

$(function(){
  $('.js_works-items').BlackAndWhite({
        hoverEffect : true,
        webworkerPath : false,
        invertHoverEffect: true,
        intensity:1,
        speed: {
            fadeIn: 500, 
            fadeOut: 800
        },
        onImageReady:function(img) {
        }
    });
});

  var mySwiper = new Swiper ('.swiper-container', {
    loop: true,
    slidesPerView: 2,
    slideToClickedSlide: true,
    observer: true,
    observeParents: true,
      pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

if (matchMedia('(max-width: 768px)').matches) {
  // ウィンドウサイズが768px以下のとき
      $(function() {
$('.js_sort-hover,.js_tab-group,.js_tab-group:before').hover(function() {
$('.js_tab-group').addClass('t-active')
}, function() {
$('.js_tab-group').removeClass('t-active')
});
});
    document.addEventListener('click', (e) => {
  if(!e.target.closest('.js_sort-hover')) {
    $('.top .js_tab-group.visible').removeClass('visible');
  } else {
    //ここに内側をクリックしたときの処理
  }
})
      $('.js_sort-hover').click(function(){
          $('.top .js_tab-group').addClass('visible');
          $('.top .js_tab-group').removeClass('hidden');
          $('.top .js_sort-hover').addClass('on');
          $('.top .js_sort ul li:nth-child(1)').addClass('on');
          $('.top .js_scroll-tab.isActive').addClass('on');
    });
    $('button.all').click(function(){
          $('.top .js_tab-group').removeClass('visible');
          $('.top .js_tab-group').addClass('hidden');
          $('.top .js_sort-hover').removeClass('on');
          $('.top .js_sort ul li:nth-child(1)').removeClass('on');
          $('.top .js_scroll-tab.isActive').removeClass('on');
    });
    $('.bottom .js_sort-hover').click(function(){
          $('.bottom .js_tab-group').addClass('visible');
          $('.bottom .js_tab-group').removeClass('hidden');
          $('.bottom .js_sort-hover').addClass('on');
          $('.bottom .js_sort ul li:nth-child(1)').addClass('on');
          $('.bottom .js_scroll-tab.isActive').addClass('on');
    });
    $('button.all').click(function(){
          $('.bottom .js_tab-group').removeClass('visible');
          $('.bottom .js_tab-group').addClass('hidden');
          $('.bottom .js_sort-hover').removeClass('on');
          $('.bottom .js_sort ul li:nth-child(1)').removeClass('on');
          $('.bottom .js_scroll-tab.isActive').removeClass('on');
    });
    $('input').click(function(){
      $('.bottom .js_tab-group').removeClass('visible');
    });
} else {
  // それ以外

          $('.js_scroll-tab').hover(
          function(e) {
          $('.js_scroll-tab').addClass('on');
        },
        function(e) {
          $('.js_scroll-tab').removeClass('on');
        }
    );
      $('.top .js_sort-hover, .top .js_tab-group').hover(
    　　function(e) {
          $('.top .js_tab-group').addClass('visible');
          $('.top .js_tab-group').removeClass('hidden');
          $('.top .js_sort-hover').addClass('on');
          $('.top .js_sort ul li:nth-child(1)').addClass('on');
          $('.top .js_scroll-tab.isActive').addClass('on');
    　　},
    　　function(e) {
          $('.top .js_tab-group').addClass('hidden');
          $('.top .js_tab-group').removeClass('visible');
          $('.top .js_sort-hover').removeClass('on');
          $('.top .js_sort ul li:nth-child(1)').removeClass('on');
          $('.top .js_scroll-tab.isActive').removeClass('on');
    　　}
    );
    $('.bottom .js_sort-hover, .bottom .js_tab-group').hover(
    　　function(e) {
          $('.bottom .js_tab-group').addClass('visible');
          $('.bottom .js_tab-group').removeClass('hidden');
          $('.bottom .js_sort-hover').addClass('on');
          $('.bottom .js_sort ul li:nth-child(1)').addClass('on');
          $('.bottom .js_scroll-tab.isActive').addClass('on');
    　　},
    　　function(e) {
          $('.bottom .js_tab-group').addClass('hidden');
          $('.bottom .js_tab-group').removeClass('visible');
          $('.bottom .js_sort-hover').removeClass('on');
          $('.bottom .js_sort ul li:nth-child(1)').removeClass('on');
          $('.bottom .js_scroll-tab.isActive').removeClass('on');
    　　}
    );
    $(function() {
$('.js_sort-hover,.js_tab-group').hover(function() {
  setTimeout(function() {
$('.js_tab-group').addClass('t-active')
},470);
}, function() {
  setTimeout(function() {
$('.js_tab-group').removeClass('t-active')
},470);
});
});
}

//下から表示させる要素を指定
  let $pagetop = $('.js_scroll-tab');

  $(window).on( 'scroll', function () {
    //スクロール位置を取得
    if ( $(this).scrollTop() < 100 ) {
      $pagetop.removeClass('isActive');
      $pagetop.addClass('hidden');
    } else {
      $pagetop.removeClass('hidden');
      $pagetop.addClass('isActive');
    }
  });

let $winS = $(window);
$winS.on('load resize', function() {
  var windowWidth = window.innerWidth;
  if (windowWidth > 768) {
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}
  $(window).on("scroll", function() {
    if($(window).scrollTop() + $(window).height() > getDocHeight() - 358) {
      $(".js_scroll-tab").addClass('sticky');
    } else{
      $(".js_scroll-tab").removeClass('sticky');
    }
  });
  } else {
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}
  $(window).on("scroll", function() {
    if($(window).scrollTop() + $(window).height() > getDocHeight() - 200) {
      $(".js_scroll-tab").addClass('sticky');
    } else{
      $(".js_scroll-tab").removeClass('sticky');
    }
  });
  }
});

/**
 * チェックボックス
 **/
$(function() {
  $(".label").click(function() {
    $(".js_works-items").removeClass("toggle");
  });
  if ($(".js_works-items").hasClass("toggle")) {
    $(".reset .reset-button").click(function() {
      $(".js_works-items").addClass("toggle");
    });
  }
});

var searchBox = '.js_tab'; // 絞り込む項目を選択するエリア
var listItem = '.js_works-items';   // 絞り込み対象のアイテム
var hideClass = 'is-hide';     // 絞り込み対象外の場合に付与されるclass名

$(function() {
  $(document).on("change", searchBox + " input", function() {
      setTimeout(function() {
        search_filter();
    }, 350);
  });
});

$(function() {
// 画像の親要素を取得・変数定義（この場合クラスを利用）
var target = document.getElementsByClassName('bl_works_archive');
// DOM操作時の動き
function loadSearch() {
  // 非表示状態を解除
    search_filter();
    $('.is-hide').addClass('hidden-v');
}
// MutationObserver登録・処理
var mo = new MutationObserver(loadSearch);
 //だいたいの場合でtargetは複数あって、配列になるのでeachで処理
$(target).each( function(i){
  mo.observe(target[i], {childList: true});
});
});

/**
 * リストの絞り込みを行う
 */
function search_filter() {
  // 非表示状態を解除
  $(listItem).removeClass(hideClass);
  for (var i = 0; i < $(searchBox).length; i++) {
    var name = $(searchBox).eq(i).find('input').attr('name');
    // 選択されている項目を取得
    var searchData = get_selected_input_items(name);
    // 選択されている項目がない、またはALLを選択している場合は飛ばす
    if(searchData.length === 0 || searchData[0] === '') {
      continue;
    }
    // リスト内の各アイテムをチェック
    for (var j = 0; j < $(listItem).length; j++) {
      // アイテムに設定している項目を取得
      var itemData = get_setting_values_in_item($(listItem).eq(j), name);
      // 絞り込み対象かどうかを調べる
      var check = array_match_check(itemData, searchData);
      if(!check) {
        $(listItem).eq(j).addClass(hideClass);
      }
    }
  }
}

/**
 * inputで選択されている値の一覧を取得する
 * @param  {String} name 対象にするinputのname属性の値
 * @return {Array}       選択されているinputのvalue属性の値
 */
function get_selected_input_items(name) {
  var searchData = [];
  $('[name=' + name + ']:checked').each(function() {
    searchData.push($(this).val());
  });
  return searchData;
}

/**
 * リスト内のアイテムに設定している値の一覧を取得する
 * @param  {Object} target 対象にするアイテムのjQueryオブジェクト
 * @param  {String} data   対象にするアイテムのdata属性の名前
 * @return {Array}         対象にするアイテムのdata属性の値
 */
function get_setting_values_in_item(target, data) {
  var itemData = target.data(data);
  if(!Array.isArray(itemData)) {
    itemData = [itemData];
  }
  return itemData;
}

/**
 * 2つの配列内で一致する文字列があるかどうかを調べる
 * @param  {Array} arr1 調べる配列1
 * @param  {Array} arr2 調べる配列2
 * @return {Boolean}    一致する値があるかどうか
 */
function array_match_check(arr1, arr2) {
  // 絞り込み対象かどうかを調べる
  var arrCheck = false;
  for (var i = 0; i < arr1.length; i++) {
    if(arr2.indexOf(arr1[i]) >= 0) {
      arrCheck = true;
      break;
    }
  }
  return arrCheck;
}

$(document).on("click", "button.all", function(){
  setTimeout(function() {
    var ele = document.getElementsByName("type");
    for(var i=0;i<ele.length;i++)
    ele[i].checked = false;
    var eleb = document.getElementsByName("type-b");
    for(var i=0;i<eleb.length;i++)
    eleb[i].checked = false;
    $('.js_works-items').removeClass('is-hide');
    $('.hidden-v').removeClass('is-hide');
    $('.js_tab-group ul li.checked').removeClass('checked');
    }, 400);
    $('.bl_works_archive').fadeOut();
    $('.bl_works_archive').fadeIn();
});

$(document).on("click", "button.all", function(){
  var ele = document.getElementsByName("member");
  for(var i=0;i<ele.length;i++)
  ele[i].checked = false;
  var eleb = document.getElementsByName("member-b");
  for(var i=0;i<eleb.length;i++)
  eleb[i].checked = false;
  $('.tab-wrap.js_scroll-tab.on').removeClass('on');
});

$(".js_works_tab-type ul li").click(function(){
  $(".js_works_tab-type ul li").removeClass('checked');
  $(this).addClass('checked');
});

$(".js_works_tab-member ul li").click(function(){
  $(".js_works_tab-member ul li").removeClass('checked');
  $(this).addClass('checked');
});

$(".js_sort ul.select li:nth-child(1)").click(function(){
  $(".js_sort ul.select li:nth-child(1)").addClass('clicked');
  $('li.js_sort-hover.sort-on').removeClass('sort-on');
  $('.js_scroll-tab').removeClass('result-on');
  $('.results').removeClass('visible');
  $('#type-result').html('<li id="type-result"></li>');
  $('#member-result').html('<li id="type-member"></li>');
  $('#type-result-b').html('<li id="type-result-b"></li>');
  $('#member-result-b').html('<li id="type-member-b"></li>');
});

$('.js_tab-group input[type="radio"]').click(function(){
  $('.bl_works_archive').fadeOut();
  $('.bl_works_archive').fadeIn();
});

$('.js_tab-group input[type="radio"]').click(function(){
  setTimeout(function() {
    $('.hidden-v').removeClass('hidden-v');
      $('.is-hide').addClass('hidden-v');
    }, 400);
});

$(".ly_main_member ul li:last-child .btn").hover(function(){
  $(this).parent().parent().parent().find(".line").addClass("hover");
}, function() {
  $(this).parent().parent().parent().find(".line").removeClass("hover");
});

var touch = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

if(touch) {
  try {
    for (var si in document.styleSheets) {
      var styleSheet = document.styleSheets[si];
      if (!styleSheet.rules) continue;

      for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        if (!styleSheet.rules[ri].selectorText) continue;

        if (styleSheet.rules[ri].selectorText.match(':hover')) {
          styleSheet.deleteRule(ri);
        }
      }
    }
  } catch (ex) {}
}
